module.exports = __webpack_public_path__ + "img/netgsm-logo.d88da161.svg";